const question2 = {
    'question': 'Jakich zmian w relacji można oczekiwać od terapii par?',
    'answer': 'Najważniejszym celem terapii par jest dojście do wzajemnego zrozumienia partnerów, umiejętność prowadzenia konstruktywnej rozmowy zamiast kłótni oraz wspólne rozwiązanie problemów między małżonkami.'
}

export default question2;